import React, { useState } from 'react';
import Links from './pages/Links';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { GlobalStyle, Layout, darkTheme, lightTheme } from './style';
import { ThemeProvider } from 'styled-components';
import { IconContext } from 'react-icons';

const App = () => {
    const [isDark, setIsDark] = useState(false);

    const toggleTheme = () => setIsDark((prev) => !prev);

    return (
        <>
            <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
                <GlobalStyle />
                <Router>
                    <IconContext.Provider value={{ size: '2em' }}>
                        <Navbar toggleTheme={toggleTheme} isDark={isDark} />
                    </IconContext.Provider>
                    <Layout>
                        <IconContext.Provider value={{ size: '1.5em' }}>
                            <Switch>
                                <Route path='/' exact component={Home} />
                                <Route path='/links' component={Links} />
                            </Switch>
                        </IconContext.Provider>
                    </Layout>
                    <Footer />
                </Router>
            </ThemeProvider>
        </>
    );
};

export default App;
